export default __webpack_public_path__ + "static/media/Move_Still.fbe30256.png";